// Small bits of state that must survive the full page reload used by the
// start/stop flow. Kept out of redux-persist on purpose (the impersonation
// slice itself is re-hydrated from the server on every boot).

const RETURN_PATH_KEY = 'impersonation.returnPath';
const JUST_ENDED_KEY = 'impersonation.justEnded';

export const saveReturnPath = (path: string): void => {
  try {
    localStorage.setItem(RETURN_PATH_KEY, path);
  } catch {
    /* ignore storage failures */
  }
};

export const readReturnPath = (): string | null => {
  try {
    return localStorage.getItem(RETURN_PATH_KEY);
  } catch {
    return null;
  }
};

export const clearReturnPath = (): void => {
  try {
    localStorage.removeItem(RETURN_PATH_KEY);
  } catch {
    /* ignore */
  }
};

export const markImpersonationJustEnded = (): void => {
  try {
    localStorage.setItem(JUST_ENDED_KEY, '1');
  } catch {
    /* ignore */
  }
};

export const consumeImpersonationJustEnded = (): boolean => {
  try {
    if (localStorage.getItem(JUST_ENDED_KEY)) {
      localStorage.removeItem(JUST_ENDED_KEY);
      return true;
    }
    return false;
  } catch {
    return false;
  }
};
